import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UserAgentDetectUtilities {
    isIE(): boolean {
        return this.isEdge() || this.isIE11();
    }

    isIE11(): boolean {
        return (
            navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > 0
        );
    }

    isEdge(): boolean {
        return navigator.userAgent.indexOf('Edge') !== -1;
    }
}
